const React = require("react");
const noop = require("mn-utils/noop");

const withState = require('../../../../../../utils/withState');
const WrapperWithLoading = require('../../../../../dumb/WrapperWithLoading');

const DashboardRetailersStats = require("../DashboardRetailersStats");
const DashboardRefLink = require("../DashboardRefLink");
const {apiV2ReferralStatsAndLinks} = require("../../../../../../api/referral/dashboard");

module.exports = withState((setState, self, onMount) => {
  self.state = {
    ...self.state,
    data: {},
    loading: true
  };

  onMount(() => {
    apiV2ReferralStatsAndLinks().then((data) => setState({data, loading: false}));
  });

  return (state, props) => {
    const {loading, data = {}} = state;

    console.log(data);

    return (
      <>
        <div>
          <WrapperWithLoading loading={loading}>
            <DashboardRetailersStats
              retailersAdded={data.invited_count}
              retailersActive={data.active_count}
            />
          </WrapperWithLoading>
        </div>
        <div>
          <WrapperWithLoading loading={loading}>
            <DashboardRefLink
              acceptance={data.referral_code}
              onRamp={''}
            />
          </WrapperWithLoading>
        </div>
      </>
    )
  }
})
